import React from 'react';
import { PageStrings } from '@alltrails/shared/utils/constants/pageStringHelpers';
import NavigationHeader from '@alltrails/shared/components/NavigationHeader';
import useIpCountryCode from 'hooks/useIpCountryCode';
import RoadblockedAnchor from 'react_components/branch/roadblocked_anchor';
import useUser from 'hooks/useUser';
import { Context } from '@alltrails/shared/types/context';
import MobileHomeLink from './MobileHomeLink';
import * as styles from './styles/styles.module.scss';
import CustomProvider from '../CustomProvider';

type NavigationWrapperProps = {
  context: Context;
  currentPage: string;
  locationSlug: string;
};

const Right = ({ context, currentPage, locationSlug }: NavigationWrapperProps): JSX.Element => {
  const user = useUser();

  if (currentPage !== PageStrings.EXPLORE_ALL_PAGE) {
    if (locationSlug) {
      return (
        <div className={styles.rightContainer}>
          <RoadblockedAnchor
            cssId="mobile-explore-link"
            user={user}
            event="trail_header_map"
            href={`/explore/${locationSlug}?mobileMap=true`}
            innerHTML="Map"
            mobileBrowser={context.mobileBrowser}
            languageRegionCode={context.languageRegionCode}
          />
        </div>
      );
    }

    // pathname does not include the language code
    if (__AT_DATA__.pathname === '/' && !user?.pro) {
      return (
        <div className={styles.rightContainer}>
          <MobileHomeLink />
        </div>
      );
    }
  }

  return <div className={styles.mobileRightSpacer} />;
};

const Navigation = ({ context, currentPage, locationSlug }: NavigationWrapperProps): JSX.Element => {
  const ipCountryCode = useIpCountryCode();
  const user = useUser();

  return (
    <NavigationHeader
      // @ts-ignore - mismatch between monolith and monorepo Context of featureFlags
      context={context}
      inUS={ipCountryCode === 'US'}
      rightChildren={<Right context={context} locationSlug={locationSlug} currentPage={currentPage} />}
      user={user}
    />
  );
};

function Wrapper({ context, currentPage, locationSlug }: NavigationWrapperProps) {
  return (
    <CustomProvider>
      <Navigation context={context} currentPage={currentPage} locationSlug={locationSlug} />
    </CustomProvider>
  );
}

export default Wrapper;
